import { APIClient } from "../../../helpers/api_helper";
import getAuthUserStorage from "../../../helpers/getAuthUserStorage";

const api = new APIClient();

// Get current user role
export const getUserRole = () => {
  const authUser = getAuthUserStorage();

  // Handle both array and string formats
  let role = authUser?.roles || authUser?.role || null;

  // If roles is an array, get the first element
  if (Array.isArray(role) && role.length > 0) {
    role = role[0];
  }

  return role;
};

// Fetch users based on role
export const fetchUsers = async (params) => {
  const userRole = getUserRole();

  // Super Admin and Admin can use /admin/users endpoint
  if (userRole === "SUPER_ADMIN" || userRole === "ADMIN") {
    return api.get("/admin/users", params);
  }

  // Tenant Admin and regular users use /api/tenant/users endpoint
  return api.get("/api/tenant/users", params);
};

export const updateUser = async (id, data) => {
  const userRole = getUserRole();

  // Tenant Admin uses /admin/tenant/users endpoint
  if (userRole === "TENANT_ADMIN") {
    return api.update(`/admin/tenant/users/${id}`, data);
  }

  // Super Admin and Admin use /admin/user endpoint
  return api.update(`/admin/user/${id}`, data);
};

export const deleteUser = async (id) => {
  return api.delete(`/admin/users/${id}`);
};

export const fetchUserLoginLogs = async (userId, params = {}) => {
  return api.get(`/admin/users/${userId}/login-logs`, params);
};

export const lockUser = async (userId, lockUntil) => {
  return api.update(`/admin/users/${userId}/lock`, { lockUntil });
};

export const unlockUser = async (userId) => {
  return api.update(`/admin/users/${userId}/unlock`, {});
};

export const createUser = async (userData) => {
  return api.create("/admin/users", userData);
};

export const resendUserInvitation = async (userId) => {
  return api.create(`/admin/users/${userId}/resend-invite`, {});
};

export const activateUser = async (userId) => {
  return api.update(`/admin/users/${userId}/activate`, {});
};

export const deactivateUser = async (userId) => {
  return api.update(`/admin/users/${userId}/deactivate`, {});
};

export const impersonateUser = async (userId) => {
  return api.create(`/admin/users/${userId}/impersonate`, {});
};

export const fetchRoles = async () => {
  return api.get("/admin/roles");
};

// Check if user has permission for a specific action
export const checkUserPermission = (action) => {
  const userRole = getUserRole();

  // We only have 4 roles: SUPER_ADMIN, ADMIN, TENANT_ADMIN, TENANT_USER
  const permissions = {
    SUPER_ADMIN: [
      "create",
      "edit",
      "delete",
      "activate",
      "deactivate",
      "loginAs",
      "viewLogs",
      "resendInvite",
    ],
    ADMIN: ["viewLogs", "resendInvite", "loginAs"],
    TENANT_ADMIN: [
      "create",
      "edit",
      "delete",
      "activate",
      "deactivate",
      "viewLogs",
      "resendInvite",
    ],
    TENANT_USER: ["view", "viewLogs", "resendInvite"],
  };

  const userPermissions = permissions[userRole] || ["view"];
  return userPermissions.includes(action);
};
